import {appContainer} from "../contexts/app";
import Resource from "./resource";
import {fromImmutable, toImmutable, setInState, setListInState, deleteInState, validate} from "./hooks";

export default app => {
  const service = app.service("api/marker-types");
  // Lengthen the timeout to allow for image uploads
  service.timeout = 20000;

  const MarkerTypeRecord = Resource(service, {
    account_id: "",
    category_id: "",
    name: "",
    image: {}
  });

  const validateMarkerType = validate({
    name: "Marker type name is required.",
    category_id: "Marker type category is required.",
    "image.path": "An image is required."
  });

  appContainer.MarkerTypeRecord = MarkerTypeRecord;
  app.set("MarkerTypeRecord", MarkerTypeRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable, validateMarkerType],
      update: [fromImmutable, validateMarkerType],
      patch: [fromImmutable, validateMarkerType],
      remove: []
    },

    after: {
      all: [toImmutable(MarkerTypeRecord)],
      find: [setListInState("markerTypes")],
      get: [setInState("markerTypes")],
      create: [setInState("markerTypes")],
      update: [setInState("markerTypes")],
      patch: [setInState("markerTypes")],
      remove: [deleteInState("markerTypes")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/marker-types.js